import React, { useCallback, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import { useOperatorPilotContext } from 'src/contexts/operator-pilot.context';
import { IOperatorPilot } from 'src/models/operator-pilot.model';
import Lang from 'src/libraries/language';
import { getOperatorPilotStatus } from 'src/selectors/operator-pilot.selector';
import { actionTypes } from 'src/ducks/operator-pilot.duck';
import style from '../operator-pilot-relationship-list/operator-pilot-relationship-list.module.scss';

type IProp = {
  data: IOperatorPilot;
};

const OperatorPilotsDelete: React.FC<IProp> = ({ data }) => {
  const { state, actions } = useOperatorPilotContext();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const deleteStatus = getOperatorPilotStatus(
    state,
    actionTypes.OPERATOR_PILOT_DELETE
  );

  const handleDelete = useCallback(async () => {
    if (data.opId) {
      const response = await actions.itemDELETE(data.opId);
      if (!response.error) {
        ToastSuccess(Lang.MSG_OPERATOR_PILOT_DELETE_SUCCESS);
        setIsDeleteOpen(false);
        actions.listGET();
      } else {
        ToastError(response.error.message);
      }
    }
  }, [actions, data]);

  return (
    <ATMModal
      open={isDeleteOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={style.actionIcon}
          basic
          icon="trash alternate outline"
          onClick={() => setIsDeleteOpen(true)}
        />
      }
      header={Lang.LBL_DELETE_OPERATOR_PILOT}
      content={
        <div className={style.content}>
          {Lang.MSG_OPERATOR_PILOT_CONFIRM_DELETE}
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => setIsDeleteOpen(false)}
          />
          <ATMButton
            negative
            content={Lang.LBL_YES_DELETE}
            onClick={handleDelete}
            disabled={deleteStatus.fetching}
            loading={deleteStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default OperatorPilotsDelete;
